export default __webpack_public_path__ + "static/media/keenpoint-logo-horizontal.691fb0cd.png";